import React from 'react';
import { Box } from '@mui/material';

/**
 * Shared wizard step icon for every multi-step wizard in the app (NPA, Validation
 * Protocol, …). Always renders the step number — never swaps to a checkmark on
 * completed steps, which MUI's default `StepIcon` does with no opt-out. Tone alone
 * signals state: green when completed, blue when active, grey when not yet reached.
 *
 * Wired as the app-wide default via `MuiStepLabel.defaultProps.StepIconComponent`
 * in `theme.js`, so any <StepLabel> picks it up without per-wizard wiring. A wizard
 * can still override it by passing its own `StepIconComponent`.
 */
export default function WizardStepIcon({ active, completed, icon }) {
  const bg = completed ? 'success.main' : active ? 'primary.main' : 'action.disabled';
  return (
    <Box
      sx={{
        width: 28, height: 28, borderRadius: '50%',
        bgcolor: bg, color: 'common.white',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontWeight: 700, fontSize: 14, lineHeight: 1,
      }}
    >
      {icon}
    </Box>
  );
}
